import { Component } from '@angular/core';
import { ChatCardComponent } from '../common/chat-card/chat-card.component';

@Component({
  selector: 'app-projects',
  imports: [ChatCardComponent],
  templateUrl: './projects.component.html',
  styleUrl: './projects.component.scss',
})
export class ProjectsComponent {}
